export const ADD_TO_CART_QUANTITY = "ADD_TO_CART_QUANTITY";
export const TOGGLE_CART_DRAWER = "TOGGLE_CART_DRAWER";
export const TOGGLE_CART_DRAWER_MOB = "TOGGLE_CART_DRAWER_MOB";
export const ADD_TO_CART_PROPERTY_UNITS = "ADD_TO_CART_PROPERTY_UNITS";
